module.exports = __webpack_public_path__ + "img/terrace.5d4abf46.jpg";